export default "__VITE_ASSET__BBKW9hjc__"